import { render, staticRenderFns } from "./processed.vue?vue&type=template&id=270e6bb0&scoped=true&"
import script from "./processed.vue?vue&type=script&lang=js&"
export * from "./processed.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=270e6bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e6bb0",
  null
  
)

export default component.exports